import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import Grid from '@mui/material/Grid2'
import Typography from '@mui/material/Typography'
import { indexOf } from 'lodash'
import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Files } from '../../pages/InternalPage/RequestSettingPage/components/Files'
import { useFilesStore } from '../../store/storeFiles'

export const FileListDialog = ({ open, handleClose, projectId }) => {
    const params = useParams()
    const {
        isLoadingFileDelete,
        fetchFilesUser,
        filesUser,
        setFileUrlList,
        fileUrlList,
        setChoiceFileUrl,
    } = useFilesStore((state) => state)

    const handleClickAddFiles = async () => {
        setChoiceFileUrl(true)
        handleClose()
    }

    const handleClickClose = async () => {
        setChoiceFileUrl(false)
        setFileUrlList([])
        handleClose()
    }

    useEffect(() => {
        fetchFilesUser({
            prefix: '/' + projectId + '/',
        })
    }, [])

    const handleClickSetFileUrlList = (url) => {
        const index = indexOf(fileUrlList, url)
        if (index > -1) {
            const items = [...fileUrlList]
            items.splice(index, 1)
            setFileUrlList(items)
        } else {
            const items = [...fileUrlList, url]
            setFileUrlList(items)
        }
    }

    return (
        <>
            <Dialog
                PaperProps={{
                    style: {
                        width: filesUser && filesUser.length > 0 ? '80%' : '600px',
                        maxWidth: filesUser && filesUser.length > 0 ? '80%' : '600px',
                    },
                }}
                open={open}
                onClose={handleClose}>
                <DialogTitle>Вложения проекта</DialogTitle>
                <DialogContent>
                    {filesUser && filesUser.length > 0 ? (
                        <>
                            <DialogContentText>Выбранно: {fileUrlList?.length}</DialogContentText>
                            <Grid container spacing={2} m={2}>
                                <Files
                                    viewFileList="card"
                                    isRequestPage={false}
                                    handleClick={handleClickSetFileUrlList}
                                />
                            </Grid>
                        </>
                    ) : (
                        <Typography>Выбранный проект не содержит вложенного контекста</Typography>
                    )}
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClickClose} variant="outlined" color="primary">
                        Отмена
                    </Button>
                    {filesUser && filesUser.length > 0 && (
                        <Button
                            onClick={handleClickAddFiles}
                            color="error"
                            variant="outlined"
                            disabled={isLoadingFileDelete}>
                            Добавить
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        </>
    )
}
